/**
 * Lageprompt-Sektion (Übersichtstab, unten): der fertige KI-Prompt
 * (Template + Lagedaten) zum Kopieren.
 */

import { useState } from 'react'
import { Check, ChevronDown, ChevronUp, ClipboardCopy, Sparkles } from 'lucide-react'
import { useMunicipalityLageprompt } from '../../hooks/queries'

interface LagepromptSectionProps {
  municipalityKey: string
}

export function LagepromptSection({ municipalityKey }: LagepromptSectionProps) {
  const { data, isLoading } = useMunicipalityLageprompt(municipalityKey)
  const [expanded, setExpanded] = useState(false)
  const [copied, setCopied] = useState(false)

  // Ohne aktives Prompt-Template (kommt nur aus der DB) gibt es keinen Prompt -> Sektion aus.
  if (isLoading || !data || !data.prompt) return null

  const handleCopy = async () => {
    if (!data.prompt) return
    await navigator.clipboard.writeText(data.prompt)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className="bg-white rounded-lg border border-gray-200 mt-6">
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
        <div className="flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-primary" />
          <div>
            <h3 className="font-medium text-gray-900">Lageprompt</h3>
            <p className="text-xs text-gray-500">
              Fertiger Prompt für die KI-Lagebeschreibung ({data.prompt.length.toLocaleString('de-DE')} Zeichen)
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={handleCopy}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-md bg-primary text-white hover:opacity-90 transition-opacity"
          >
            {copied ? <Check className="w-4 h-4" /> : <ClipboardCopy className="w-4 h-4" />}
            {copied ? 'Kopiert' : 'Prompt kopieren'}
          </button>
          <button
            onClick={() => setExpanded((v) => !v)}
            className="inline-flex items-center gap-1 px-3 py-1.5 text-sm rounded-md border border-gray-300 hover:bg-gray-50 transition-colors"
          >
            {expanded ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
            {expanded ? 'Einklappen' : 'Anzeigen'}
          </button>
        </div>
      </div>
      {expanded && (
        <pre className="p-4 text-xs leading-relaxed whitespace-pre-wrap font-mono text-gray-800 max-h-[60vh] overflow-y-auto">
          {data.prompt}
        </pre>
      )}
    </div>
  )
}
